module.exports = __webpack_public_path__ + "img/map-placeholder2.415c761a.jpg";